<template>
    <div>
        <b-button class="noborder-button download" @click="createPDF_Logbook()">
            <i class="fas fa fa-1x fa-download mr-2"></i>{{ $t("download") }}
        </b-button>
    </div>
</template>

<script>
import { mapState } from "vuex";
//import for pdf conversion
import jsPDF from 'jspdf'
import JsPDFAutotable from 'jspdf-autotable' 
import { report } from "process";
import { start } from "repl";


export default {
	name: "DownloadPdfSingleReport",
	components:{
		jsPDF,
		JsPDFAutotable
	},
	data() {
		return {
			reportItems: [],
			reportTestFields: [
				{ key: "dataEv", label: this.$t("cards.date_report") },
				{ key: "cod", label: this.$t("cards.central_type") },
				{ key: "evEsito", label: this.$t("cards.result"), tdClass: "text-center align-middle" },
				{ key: "evDesc", label: this.$t("cards.title_report"), tdClass: "align-middle" }
			],
			// Data properties to hold the loaded font strings
			robotoRegular: null,
			robotoBold: null,
			imgData : 'data:image/jpeg;base64,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'
		};
	},
	props: {
		report:null,
		plant:null
	},
	mounted() {
		// Load fonts when the component is mounted
		this.loadFonts();
	},

	methods: {
		//Loads all required fonts and stores them in component data.
		async loadFonts() {
			try {
				// Assumes fonts are in your 'public' folder
				this.robotoRegular = await this.loadFontAsBase64('/fonts/Roboto-Regular.ttf');
				this.robotoBold = await this.loadFontAsBase64('/fonts/Roboto-Bold.ttf');
				//console.log('Fonts loaded successfully.');
			} catch (error) {
				console.error('Failed to load fonts:', error);
			}
		},        
		// Helper function to load a font from a URL and convert it to Base64
		async loadFontAsBase64(url) {
			const response = await fetch(url);
			// console.log("fetch font: ", response);
			const blob = await response.blob();
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onloadend = () => {
					// Get the Base64 string, but strip the "data:..." prefix
					const base64data = reader.result.split(',')[1];
					resolve(base64data);
				};
				reader.onerror = reject;
				reader.readAsDataURL(blob);
			});
		},

        //----------------------------------------------------
        //Report single logbook  
        //---------------------------------------------------- 
		async createPDF_Logbook() 
		{
			var num_lamp_error=0;
			var num_lamp_pass=0;

			const self = this;
			var posY = 200;
			var columnsLAMP = [];
			var rowsLAMP = [];

			console.log("Download report: ", self.report);

			if (this.report.log_system === 'sicuro') {

			// ***************Tabella CU*******************
				var columnsCU = [
					{title: self.$t('report_pdf.title_cu'), dataKey: "id"},
					{title: self.$t('report_pdf.title_desc_lamp'), dataKey: "desc"}, 
					{title: self.$t('report_pdf.title_tipo_lamp'), dataKey: "tipo"}, 
					{title: self.$t('report_pdf.title_durata_test'), dataKey: "durata"}, 
					{title: self.$t('report_pdf.title_esito_lamp'), dataKey: "esito"},
					{title: self.$t('report_pdf.title_error_lamp'), dataKey: "errori"},
					{title: self.$t('report_pdf.title_note_lamp'), dataKey: "notes"}
				];
				
				var rowCU = [];
				// var unit = this.$store.state.plantUnits.find( (cu) => {
				//     return (cu.cu_id === this.report.cu_id);
				// });
				console.log("log_cu: ", this.report.log_cu);
				var unit = this.$store.state.plantUnits.find( cu => cu.cu_id == this.report.cu_id);
				var str_errori = this.getErroriCentrale(this.report.log_cu[0]);
				var str_esito = "Pass"
				if (str_errori.length > 0) {
					str_esito = "Fail";
					str_errori = str_errori.substring(2);
				} 
				
				//var str_note = "Tinit=" + this.report.log_cu[0].temperature_start + "\n" + "Tend=" + this.report.log_cu[0].temperature_end;
				var str_note = "Tbat=" + this.report.log_cu[0].temperature_end + " °C";
				rowCU.push({ id: this.report.cu_id, desc: unit.cu_product_desc, tipo: unit.cu_type, durata: this.report.log_cu[0].durata_test, esito: str_esito , errori: str_errori, notes: str_note});
			// ***************Fine Tabella CU*******************
				
				var bLineePresenti = false;
				
			// ***************Tabella LINEE*******************
				if (this.report.log_lines.length > 0) {
					bLineePresenti = true;
					// Tabella LINEE
					var columnsLN = [
						{title: self.$t('report_pdf.title_ak'), dataKey: "ak"},
						{title: self.$t('report_pdf.title_index'), dataKey: "index"},                         
						{title: self.$t('report_pdf.title_tipo_lamp'), dataKey: "tipo"},                        
						{title: self.$t('report_pdf.title_esito_lamp'), dataKey: "esito"},
						{title: self.$t('report_pdf.title_error_lamp'), dataKey: "errori"},
					];
					var rowLN = [];
					str_errori = null;
					var lineNum = null;
					//str_note = "";
					for(var i=0; i < this.report.log_lines.length; i++) {
						str_errori = this.getErroriLines(this.report.log_lines[i]);
						str_esito = "Pass";
						if (str_errori.length > 0) {
							str_esito = "Fail";
							str_errori = str_errori.substring(2);
						}
						lineNum = this.report.log_lines[i].line_num ? "" + this.report.log_lines[i].line_num : '0'+ this.report.log_lines[i].index;
						rowLN.push({ index: lineNum, ak: this.report.log_lines[i].ak, tipo: this.$t('report_pdf.ak_int'), esito: str_esito, errori: str_errori});
						console.log("LINEA: ", rowLN);
					}
				}
			// ***************Fine Tabella LINEE*******************    


				var bLineeExtPresenti = false;
			// ***************Tabella LINEE EXT*******************               
				if (this.report.log_lines_ext.length > 0) {
					bLineeExtPresenti = true;
					// Tabella LINEE_EXT
					var columnsLNE = [
						{title: self.$t('report_pdf.title_ak'), dataKey: "ak"},
						{title: self.$t('report_pdf.title_index'), dataKey: "index"}, 
						{title: self.$t('report_pdf.title_tipo_lamp'), dataKey: "tipo"},                        
						{title: self.$t('report_pdf.title_esito_lamp'), dataKey: "esito"},
						{title: self.$t('report_pdf.title_error_lamp'), dataKey: "errori"},
						//{title: self.$t('report_pdf.title_note_lamp'), dataKey: "notes"}
					];                        
					var rowLNE = [];
					str_errori = null;
					//str_note = "";
					for(var j=0; j < this.report.log_lines_ext.length; j++) {
						str_errori = this.getErroriLines(this.report.log_lines_ext[j]);
						str_esito = "Pass";
						if (str_errori.length > 0) {
							str_esito = "Fail";
							str_errori = str_errori.substring(2);
						}
						lineNum = this.report.log_lines[j].line_num ? "" + this.report.log_lines[j].line_num : '0'+ this.report.log_lines[j].index;
						rowLNE.push({ index: lineNum, ak: this.report.log_lines_ext[j].ak, tipo: this.$t('report_pdf.ak_ext'), esito: str_esito, errori: str_errori});
						console.log("LINEA: ", rowLN);
					}
				}
			// ***************Fine Tabella LINEE EXT******************* 

			// ***************Tabella LAMPADE*********************
				// Set heading for pdf table simple logbook
				columnsLAMP = [
					{title: "", dataKey: "index"},
					{title: self.$t('report_pdf.title_ak'), dataKey: "ak"},                    
					{title: self.$t('report_pdf.title_line'), dataKey: "line"},
					{title: self.$t('report_pdf.title_id_lamp'), dataKey: "id"},
					{title: self.$t('report_pdf.title_code_lamp'), dataKey: "code"},                                        
					{title: self.$t('report_pdf.title_desc_lamp'), dataKey: "desc"}, 					
					{title: self.$t('report_pdf.title_tipo_lamp'), dataKey: "tipo"}, 
					{title: self.$t('report_pdf.title_esito_lamp'), dataKey: "esito"},
					{title: self.$t('report_pdf.title_error_lamp'), dataKey: "errori"},
					// {title: self.$t('report_pdf.title_note_lamp'), dataKey: "notes"}
				];
				rowsLAMP = [];                           
							
				//get list of lamps in logbook
				this.report.log_lamps.forEach( (lamp) => {
					//trovo la lampada in plantUnits
					var ak_esterno = false;
					var lampDet = null;
					var continua = true; //quando viene posto a false, fa uscire dai cicli every
					self.$store.state.plantUnits.filter( (c) => c.cu_type === 'sicuro').every( (u) => {
						u.ak.every( (a) => { //comincio con gli ak
							a.lines.every( (l) => {
								l.lamps.every( (la) => {
									if (la.lamp_id == lamp.id) {
										lampDet = la;
										continua = false;
									}
									return continua;
								});
								return continua;
							});
							return continua;
						});
						if (continua) { //contniuo con gli ak_ext
							u.ak_ext.every( (a) => { 
								a.lines.every( (l) => {
									l.lamps.every( (la) => {
										if (la.lamp_id == lamp.id) {
											lampDet = la;
											ak_esterno = true;
											continua = false;
										}
										return continua;
									});
									return continua;
								});
								return continua;
							});
						}
						return continua;
					});

					var tipoLampada="";
					var descLampada="";
					var codeLampada="";
					if (lampDet!=null)
					{
						tipoLampada = (lampDet.product_desc)?((lampDet.product_desc.includes('|'))?lampDet.product_desc.split('|')[0]:lampDet.product_desc):"n.d.";
						codeLampada = (lampDet.order_code)?lampDet.order_code:"n.d.";
						descLampada = lampDet.desc;
					}
					var esito = "Pass"; 
					var errori = this.getErroriSicuro(lamp);

					if (errori.length > 0) {
						esito = "Fail";
						num_lamp_error++;
						errori = errori.substring(2);
						console.log("LAMP WITH ERRORS ",lamp.id + " Errors: " + errori);
					} else {
						num_lamp_pass++;
					}
					
					// rowsLAMP.push({index:"["+lamp.index+"]" , ak: lampDet.ak_index, line: lampDet.ak_line , id: lamp.id, code: codeLampada, desc: descLampada, tipo: tipoLampada, esito: esito, errori: errori, notes: lamp.note});
					rowsLAMP.push({index:"["+lamp.index+"]" , ak: ak_esterno ? lampDet.ak_index + "_ext": lampDet.ak_index , line: lampDet.ak_line , id: lamp.id, code: codeLampada, desc: descLampada, tipo: tipoLampada, esito: esito, errori: errori});
				});
			} else { //altre centrali, non 'sicuro'
				//Set heading for pdf table simple logbook
				columnsLAMP = [
					{title: "", dataKey: "index"},
					{title: self.$t('report_pdf.title_id_lamp'), dataKey: "id"},
					{title: self.$t('report_pdf.title_code_lamp'), dataKey: "code"}, 
					{title: self.$t('report_pdf.title_desc_lamp'), dataKey: "desc"}, 					
					{title: self.$t('report_pdf.title_tipo_lamp'), dataKey: "tipo"}, 
					{title: self.$t('report_pdf.title_esito_lamp'), dataKey: "esito"},
					{title: self.$t('report_pdf.title_error_lamp'), dataKey: "errori"},
					{title: self.$t('report_pdf.title_note_lamp'), dataKey: "notes"}
				];

				rowsLAMP = [];
							
				// var battery_array=[];
							
				//get list of lamps in logbook
				this.report.log_lamps.forEach(function(lamp) {
					//sostituisco forEach() con every() per risparmiare iterazioni, poiché posso uscire appena trovo la lampada
					var lampDet = null;
					var continua = true; //quando viene posto a false, fa uscire dai cicli every
					//trovo la lampada
					self.$store.state.plantUnits.every((u) => {
						if (self.report.log_type.includes("illum"))
						{
							u.lamps_illum.every( (l) => {
								if (l.id == lamp.id) {
									lampDet = l;
									continua = false;
								}
								return continua   
							});
						} else
						{
							u.lamps.every( (l) => {
								if (l.id == lamp.id) {
									lampDet = l;
									continua = false;
								}
								return continua;
							});
						}
						return continua;
					});

					
					var tipoLampada="";
					var descLampada="";
					var codeLampada="";
					//var testDuration="1H";                   
					if (lampDet!=null)
					{
						tipoLampada = (lampDet.product_desc)?((lampDet.product_desc.includes('|'))?lampDet.product_desc.split('|')[0]:lampDet.product_desc):"n.d.";
						if (tipoLampada.toLowerCase().includes("device family unknown".toLowerCase())) {
							tipoLampada = self.$t('report_pdf.lamp_unknown');
						}
						console.log("tipoLampada: ", tipoLampada);
						codeLampada = (lampDet.order_code)?lampDet.order_code:"n.d.";
						descLampada = lamp.descr;
						//testDuration = lampDet.test_duration;
					}
					var esito = "Pass"; 
					var errori = self.getErroriLamp(self, lamp);

					if (errori.length > 0) {
						esito = "Fail";
						num_lamp_error++;
						errori = errori.substring(2);
						//console.log("LAMP WITH ERRORS ",lamp.id + " Errors: " + errori);
					} else {
						num_lamp_pass++;
					}

					// rowsLAMP.push({index:"["+lamp.index+"]" ,id: lamp.id, code:codeLampada, desc: descLampada, tipo: tipoLampada, esito: esito, errori: errori});
					rowsLAMP.push({index:"["+lamp.index+"]" ,id: lamp.id, code:codeLampada, desc: descLampada, tipo: tipoLampada, esito: esito, errori: errori, notes: lamp.note});
				});
			}

			//Create logbook date
			var dateObj = new Date(self.report.log_timestamp * 1000); 
			var format_date= dateObj.toLocaleDateString() + " " + dateObj.toLocaleTimeString() + "   (Timezone Location: " + this.$store.state.timezoneLocation + ")";

			//Define table name
			let plant_header=self.plant.plantname.replaceAll(".","");
			let table_name=this.$t("report_pdf.table_name_logbook")+plant_header +"_"+self.report.cu_id+"_"+format_date;

			// Only pt supported (not mm or in)
            const doc = new jsPDF({ 
                orientation: 'p', 
                unit: 'pt', 
                format: 'a4', 
                putOnlyUsedFonts: true, 
                floatPrecision: 16 
            });

            doc.addFileToVFS('Roboto-Regular.ttf', this.robotoRegular);
            doc.addFileToVFS('Roboto-Bold.ttf', this.robotoBold);
			// Use 'Identity-H' encoding for the font registration to enable Unicode support
            doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal', 'Identity-H');
            doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold', 'Identity-H');
			
			doc.setFont('Roboto', 'bold');
			//doc.setFontType("bold");
			doc.setFontSize(12);
			
			//Inserimento del logo come intestazione al PDF
			if (this.plant.logoId != null) {
				console.log("Esiste il logo!");
				let logoUrl = process.env.VUE_APP_API_REST_URL + "?action=getResource&type=logo&id="+this.plant.id+"&rnd=" + Math.random();
				var logoImg = new Image();
				logoImg.src = logoUrl;
				var logoData = await this.getImageData(logoImg);
				var w = 60 * logoImg.width / logoImg.height;
				//var x = (doc.internal.pageSize.getWidth() - w ) / 2;
				doc.addImage(logoData, 'PNG', 38, 15, w, 60);
			} else {
				doc.addImage(this.imgData, 'PNG', 38, 15, 70, 20);
			}         
			
			doc.text(self.$t('report_pdf.title_impianto') + " : " + self.plant.plantname,38,90);
			doc.text(self.$t('report_pdf.title_centrale') + " : " + self.report.cu_id,38,105);

			//doc.setFontType("normal");
			doc.setFont('Roboto', 'normal');
			doc.text(self.$t('report_pdf.title_data_report')+ " : " + format_date,38,120);
			doc.text(self.$t('report_pdf.title_tipo_test') + " : " + this.$t("report_table."+self.report.log_type), 38, 135);
			doc.text(self.$t('report_pdf.num_lampade_ok') + " : " + num_lamp_pass,38,150);
			doc.text(self.$t('report_pdf.num_lampade_fail') + " : " + num_lamp_error,38,165);

			if(self.report.log_lamps.some((el) => el.error_batt_test_auto=='ON'))
				doc.text(self.$t('report_pdf.title_esito') + " : " + self.$t('report_table.error_auto_in_funct') ,38,180);
			else	
				doc.text(self.$t('report_pdf.title_esito') + " : " + self.report.log_esito,38,180);
			

			if (this.report.log_system === 'sicuro') {
				//centrale
				doc.autoTable({
					columns: columnsCU, 
					body: rowCU, 
					headStyles: {
						font: "Roboto",
						fontSize: 11,
						fillColor: [0, 68, 114]
					},
					styles: {
						font: "Roboto",
						fontSize: 10
					},
					alternateRowStyles: {fillColor: [206, 229, 239]},
					startY: posY,
					columnStyles: { 
						esito: {
							font: "Roboto",
							fontStyle: 'bold'
						}
					}
				});

				posY += (100 + rowCU.length * 25);
				console.log('posY= ', posY);
				//linee
				if (bLineePresenti) {
					doc.autoTable({
						columns: columnsLN, 
						body: rowLN, 
						headStyles: {
							font: "Roboto",
							fontSize: 11,
							fillColor : [88, 106, 166]
						},
						styles: {
							font: "Roboto",
							fontSize: 10
						},
						alternateRowStyles: {fillColor : [210, 213, 220]},
						startY: posY,
						columnStyles: { 
							esito: {
								font: "Roboto",
								fontStyle: 'bold'
							}
						}
					});
					posY += (50 + rowLN.length * 25)
				}

				if (bLineeExtPresenti) {
					doc.autoTable({
						columns: columnsLNE, 
						body: rowLNE, 
						headStyles: {
							font: "Roboto",
							fontSize: 11,
							fillColor : [150, 135, 182]
						},
						styles: {
							font: "Roboto",
							fontSize: 10
						},
						alternateRowStyles: {fillColor : [219, 213, 234]},
						startY: posY,
						columnStyles: { 
							esito: {
								font: "Roboto",
								fontStyle: 'bold'
							}
						}
					});
					posY += (50 + rowLNE.length * 25)
				}
			}
			doc.autoTable({
				columns: columnsLAMP, 
				body: rowsLAMP, 
				headStyles: {
					font: "Roboto",
					fontSize: 11,
					fillColor : [0, 116, 166]
				},
				styles: {
					font: "Roboto",
					fontSize: 10
				},
				alternateRowStyles: {fillColor: [225, 239, 245]},
				startY: posY,
				columnStyles: { 
					esito: {
						font: "Roboto",
						fontStyle: 'bold'
					}
				}
			});
			doc.addImage(this.imgData, 'PNG', (doc.internal.pageSize.width/2), doc.internal.pageSize.height - 40, 70, 20);
			doc.save(table_name);
		},

        //restituisce una stringa con gli errori di una lampada LOGICA
		getErroriLamp(self, lamp)
		{
			var errori="";
			
			//check errori hardware, led, com, batt_short
			if (lamp.error_com == 'ON') errori +=", " + self.$t("details_lamp.lamp_error_com");     
			if (lamp.error_batt_short == 'ON') errori += ", " + self.$t("details_lamp.lamp_error_batt_short");
			if (lamp.error_hardware == 'ON') errori += ", " + self.$t("details_lamp.lamp_error_hardware");
			if (lamp.error_led == 'ON') errori += ", " + self.$t("details_lamp.lamp_error_led");
			if (lamp.error_tubo_UV == 'ON') errori += ", " + self.$t("details_lamp.lamp_error_tubo_UV");

			if(lamp.error_underpower=="ON") errori +=", " + self.$t("details_lamp.lamp_error_underpower");    
			if(lamp.error_undervoltage=="ON") errori +=", " + self.$t("details_lamp.lamp_error_undervoltage"); 
			if(lamp.error_overpower=="ON") errori +=", " + self.$t("details_lamp.lamp_error_overpower");       
			if(lamp.error_overvoltage=="ON") errori +=", " + self.$t("details_lamp.lamp_error_overvoltage");       
			if(lamp.error_comm_radio_lamp=="ON") errori +=", " + self.$t("details_lamp.lamp_error_comm_radio_lamp");       
			if(lamp.nodo_orfano==true) errori +=", " + self.$t("details_lamp.lamp_orphan_error");       

			//check errori batteria durante il test
			if (lamp.error_batt_test_funz == 'ON' && lamp.error_batt_short == 'OFF')  errori += ", " + self.$t("details_lamp.lamp_error_batt_test_funz");
			if (lamp.error_batt_test_auto == 'ON' && lamp.error_batt_short == 'OFF')
			{
				errori += ", " + self.$t("details_lamp.lamp_error_batt_test_auto");
				console.log("tempo residuo", JSON.stringify(lamp));
				if(lamp.residual_time)
				{
					if (parseInt(lamp.residual_time.split('min.')[0])<60 && parseInt(lamp.residual_time.split('min.')[0])!=0) 
						errori += " ("+self.$t("details_lamp.lamp_residual_time")+": " + lamp.residual_time.split('min.')[0] + "min.)";
					else if (parseInt(lamp.residual_time.split('min.')[0])>60) 
						errori += " ("+self.$t("details_lamp.lamp_residual_time")+": " + "----";
					else if (parseInt(lamp.residual_time.split('min.')[0])==0) 
						errori += " ("+self.$t("details_lamp.lamp_residual_time")+": " + "< 4 min.)";        
				}
				if(lamp.error_ricarica_incompleta=="ON")
				{
					errori = errori + "(" + self.$t("details_lamp.lamp_error_ric_incompleta") + ")";   
				}
			}

			if (lamp.error_com == 'ON' && lamp.error_hardware == 'ON' && lamp.error_batt_short == 'OFF' && lamp.error_led == 'OFF' && lamp.error_batt_test_funz == 'OFF')
				errori = ", " + self.$t("details_lamp.lamp_error_module");

			if (lamp.error_com == 'ON' && lamp.error_hardware == 'ON' && lamp.error_batt_short == 'ON' && lamp.error_led == 'ON' && lamp.error_tubo_UV =='ON')
				errori = ", " + self.$t("details_lamp.lamp_orphan_error");


			//console.log("list errori" , errori);
			return errori 
		},

        //restituisce una stringa con gli errori di una lampada SICURO
		getErroriSicuro(lamp)
		{
			var errori="";
			console.log("lamp: ", lamp);
			if (lamp.error_com_ak_lamp === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_com_ak_lamp");
            else if (lamp.error_line_fuse === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_line_fuse");
            else {
                if (lamp.error_dali_com === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_dali_com");  
                if (lamp.error_dali_hardware === 'ON') errori += ", " + this.$t("details_lamp.error_dali_hardware");
                if (lamp.error_dali_lamp === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_dali_lamp");
                if (lamp.error_id_duplicate === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_duplicate");
                if (lamp.error_led_full_short === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_led_full_short");
                if (lamp.error_led_open === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_led_open");
                if (lamp.error_led_partial_short === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_led_partial_short"); 
                if (lamp.error_low_voltage === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_low_voltage");
                if (lamp.error_polarity_reverse === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_polarity_reverse"); 
                if (lamp.error_lamp_programming === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_programming"); 
                if (lamp.error_under_threshold === 'ON') errori += ", " + this.$t("details_lamp.lamp_error_under_threshold");
            }  
			console.log("list errori SICURO: " , errori);
			return errori;
		},

		getErroriCentrale(e)
		{
			var errori=[];

			if (e.error_ak_o_luci == 'ON') errori +=", " + this.$t("details_cent.error_ak_o_luci");
			if (e.error_all_chargers_or_fuse == 'ON') errori +=", " + this.$t("details_cent.error_all_chargers_or_fuse");
			if (e.error_autonomy_test == 'ON') errori +=", " + this.$t("details_cent.error_autonomy_test");
			if (e.error_battery_fuse == 'ON') errori +=", " + this.$t("details_cent.error_battery_fuse");
			if (e.error_battery_low == 'ON') errori += ", " + this.$t("details_cent.error_battery_low");
			if (e.error_battery_simmetry == 'ON') errori += ", " + this.$t("details_cent.error_battery_simmetry");
			if (e.error_battery_temperature == 'ON') errori += ", " + this.$t("details_cent.error_battery_temperature");
			if (e.error_cabinet_isominus == 'ON') errori += ", " + this.$t("details_cent.error_cabinet_isominus");
			if (e.error_cabinet_isoplus == 'ON') errori += ", " + this.$t("details_cent.error_cabinet_isoplus");
			if (e.error_chargers == 'ON') errori += ", " + this.$t("details_cent.error_chargers");
			if (e.error_com_cpu_ak == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_ak");
			if (e.error_com_cpu_charger == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_charger");
			if (e.error_com_cpu_io == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_io");
			if (e.error_com_cpu_lssa == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_lssa");
			if (e.error_com_cpu_substation == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_substation");
			if (e.error_com_cpu_switch11kw == 'ON') errori += ", " + this.$t("details_cent.error_com_cpu_switch11kw");
			if (e.error_functional_test == 'ON') errori += ", " + this.$t("details_cent.error_functional_test");
			if (e.error_io_measures == 'ON') errori += ", " + this.$t("details_cent.error_io_measures");
			if (e.error_lamp_programming == 'ON') errori += ", " + this.$t("details_cent.error_lamp_programming");
			if (e.error_line_isolation == 'ON') errori += ", " + this.$t("details_cent.error_line_isolation");
			if (e.error_swap_lampade == 'ON') errori += ", " + this.$t("details_cent.error_swap_lampade");
			if (e.no_critical_circuit == 'ON') errori += ", " + this.$t("details_cent.no_critical_circuit");
			if (e.no_mains == 'ON') errori += ", " + this.$t("details_cent.no_mains");
			if (e.no_phase1 == 'ON') errori += ", " + this.$t("details_cent.no_phase1");
			if (e.no_phase2 == 'ON') errori += ", " + this.$t("details_cent.no_phase2");
			if (e.no_phase3 == 'ON') errori += ", " + this.$t("details_cent.no_phase3");
			if (e.no_subdistribution == 'ON') errori += ", " + this.$t("details_cent.no_subdistribution");
			if (e.system_inhibited == 'ON') errori += ", " + this.$t("details_cent.system_inhibited");
			if (e.warning_charger_off_by_temperature == 'ON') errori += ", " + this.$t("details_cent.warning_charger_off_by_temperature");
			if (e.warning_maintenance == 'ON') errori += ", " + this.$t("details_cent.warning_maintenance");
			if (e.error_power_supply_broken == 'ON') errori += ", " + this.$t("details_cent.error_power_supply_broken");
			if (e.error_power_supply_out_of_range == 'ON') errori += ", " + this.$t("details_cent.error_power_supply_out_of_range");

			console.log("list errori SICURO: " , errori);
			return errori;
		},

        getErroriLines(l)
        {
            var errori="";
 
            //check errori hardware, led, com, batt_short
            if (l.error_com_cpu_ak == 'ON') errori +=", " + this.$t("details_line.error_com");
            if (l.error_ak_su_current == 'ON') errori +=", " + this.$t("details_line.error_current");
            if (l.error_line_fuse == 'ON') errori +=", " + this.$t("details_line.error_fuse");
            if (l.error_line_isolation == 'ON') errori +=", " + this.$t("details_line.error_isolation");
            return errori;
        },
        //funzione che recupera il logo dell'installatore
        async getImageData(logo) {
            logo.crossOrigin="anonymous";
            await logo.decode();
            console.log("immagine:" + logo.width + "x" + logo.height ,logo);
            var canvas = document.createElement("canvas");
            canvas.width = logo.width;
            canvas.height = logo.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(logo, 0, 0);
            var dataURL = canvas.toDataURL("image/png");
            //console.log("logo dataurl:" + dataURL);
            return dataURL;
        },
  }
};
</script>
